const Style = {
  base: 'block w-[6em] h-[2em] mx-auto mb-4 outline-none md:w-[8em]',
};

export default Style;
